<template>
  <div class="">
<!--body content start-->

<div id="main-page" class="page-content">

<!--case study start-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>Our Work</h6>
          <h2 class="title mb-0">Explore some of our <span>latest Case Study.</span></h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-4">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/05.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>Design</span>
              <h3><a href="case-studies-single.html">Experience for Agency</a></h3>
            </div> 
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-5 mt-md-0">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/06.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>UX/UI Design</span>
              <h3><a href="case-studies-single.html">Crafted with Love</a></h3>
            </div> 
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-5 mt-lg-0">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/07.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>Branding</span>
              <h3><a href="case-studies-single.html">Colibri Identity</a></h3>
            </div> 
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-5">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/08.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>Design</span>
              <h3><a href="case-studies-single.html">Experience for Agency</a></h3>
            </div> 
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-5">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/09.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>UX/UI Design</span>
              <h3><a href="case-studies-single.html">Crafted with Love</a></h3>
            </div> 
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-5">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/10.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>Branding</span>
              <h3><a href="case-studies-single.html">Colibri Identity</a></h3>
            </div> 
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--case study end-->

</div>

<!--body content end--> 
  </div>
</template>

<script>


export default {
    data: function () {
        return {
            name: 'case-studies',
        }
    },
};
</script>
